export default [
    {
        path: '/account/login',
        name: 'login',
        component: () => import('./components/app-login.vue'),
        meta: { 
            title: 'Login'
        }, 
    },
    {
        path: '/account/register',
        name: 'register',
        component: () => import('./components/app-register.vue'),
        meta: { 
            title: 'Register'
        }
    },
    {
        path: '/account/register-sent',
        name: 'registerSent',
        component: () => import('./components/app-register-sent.vue'),
        meta: { 
            title: 'Registration Sent!'
        }, 
    },
    {
        path: '/account/register-confirmation/:uid/:code',
        name: 'registerValidate',
        component: () => import('./components/app-register-validate.vue'),
        props: true,
        meta: { 
        }, 
    },
    {
        path: '/account/register-confirmation/fail',
        name: 'registerValidateFail',
        component: () => import('./components/app-register-validate-fail.vue'),
        props: true,
        meta: { 
        }, 
    },
    {
        path: '/account/forgot-password',
        name: 'forgotPassword',
        component: () => import('./components/app-forgot-password.vue'),
        meta: { 
            title: 'Forgot Password'
        }, 
    },
    {
        path: '/account/forgot-password-sent',
        name: 'forgotPasswordSent',
        component: () => import('./components/app-forgot-password-sent.vue'),
        meta: { 
            title: 'Email Sent!'
        }, 
    }
]